import { render, staticRenderFns } from "./SloveOrder.vue?vue&type=template&id=4ef88d7d&scoped=true&"
import script from "./SloveOrder.vue?vue&type=script&lang=js&"
export * from "./SloveOrder.vue?vue&type=script&lang=js&"
import style0 from "./SloveOrder.vue?vue&type=style&index=0&id=4ef88d7d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef88d7d",
  null
  
)

component.options.__file = "SloveOrder.vue"
export default component.exports